export default __webpack_public_path__ + "static/media/psoriasis-front.0dae72cd.JPG";